import React, { useState, useEffect } from 'react'
import Grid from '@mui/material/Grid'
import { AppBar, Button, Toolbar, Typography } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu';
import { useDispatch, useSelector } from 'react-redux';
import { menuAction } from '../redux/reducers/Menu'; 
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import styled from '@mui/material/styles/styled';
import { modalDeleteAction } from '../redux/reducers/Modal';
import DangerModal from '../components/DangerModal';

const ToolbarPrimary = styled(Toolbar)(({ theme }) => `
    background-color: ${theme.palette.primary.light};
    padding: 0 2rem;
    :hover{
        background-color: ${theme.palette.primary.light};
    }
`)

const MoreInfo = styled(Button)(({ theme }) => `
    background-color: ${theme.palette.primary.light};
    padding: 0 3rem;
    height: 4rem;
    border-radius: 0 0 4px 4px;
    position: absolute;
    right: 0;
    text-align: 'start';
    margin-top: ${theme.mixins.toolbar.minHeight + 2}px;
    :hover{
        background-color: ${theme.palette.primary.dark};
    }
`)

const Menu = () => {

    const dispatch = useDispatch();

    const [ userMenu, setUserMenu ] = useState(false);
    const [ showDeleteModal, setShowDeleteModal ] = useState(false);
    const [ deleteModal, setDeleteModal ] = useState('signOut');
    const [ signOutView, setSignOutView ] = useState(false);
    const [ fullName, setFullName ] = useState('');
    const [ userRole, setUserRole ] = useState('');

    const deleteModalStatus = useSelector( state => state.Modal.deleteModalState );

    useEffect( () => {
        setShowDeleteModal(deleteModalStatus);
      }, [deleteModalStatus] );

    useEffect( () => {
        dispatch(modalDeleteAction());
        //let fullName = localStorage.getItem('ht-fullname');
        setFullName(`${localStorage.getItem('ht-fullname')}`);
        setUserRole(`${localStorage.getItem('ht-role')}`);
    }, [] );

    
    return (
        <Grid container>
        <Grid item>
            {
                (signOutView ) &&
                <DangerModal view={deleteModal} />
            }
            <AppBar sx={{ boxShadow: 0 }}>
                <Toolbar sx={{ justifyContent: 'space-between' }}>
                    <Button color="inherit" sx={{ mr: 1 }} onClick={ () => dispatch(menuAction()) }>
                        <MenuIcon />
                    </Button>

                    <Grid container sx={{ justifyContent: 'end' }} onClick={ () => setUserMenu(!userMenu) }>
                        <Button>
                        <Grid item sx={{ textTransform: 'capitalize', mr: 2 }}>
                                <p style={{ margin: '0', color: '#000' }}>{fullName}</p>
                                <p style={{ fontSize: '.8rem', margin: '0', color: '#FFF' }}>{userRole == 'admin' ? 'Administrador' : 'Recepcionista'}</p>
                        </Grid>
                        <Grid item>
                            <KeyboardArrowDownIcon style={{ color: '#000' }} />
                        </Grid>
                        </Button>
                    </Grid>
                </Toolbar>

            </AppBar>
            {
                userMenu &&
                    <MoreInfo onClick={ () => setSignOutView(true) }>
                        <Grid item sx={{ textTransform: 'capitalize', mr: 2 }}>
                            <p style={{ margin: '0', color: '#FFF' }}>Cerrar Sesión</p>
                        </Grid>
                    </MoreInfo>
            }
        </Grid>
    </Grid>
  )
}

export default Menu